(function () {
  if (window.TimberEraReviewsLoaded) return;
  window.TimberEraReviewsLoaded = true;

  var nativeCardSelector = '.jdgm-carousel-item, .jdgm-rev';
  var reviewMediaSelector = [
    '.jdgm-rev__pics img',
    '.jdgm-rev__pic-img',
    '.jdgm-rev__video-poster',
    '.jdgm-carousel-item__review-image',
    '[data-review-media] img'
  ].join(',');

  var homepageFeaturedReviews = [
    {
      "name": "LeeAnn",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "Exactly what I wanted for the watches I wear most. The clear lid is nice because I can see everything without opening it.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-5-Slot-Wooden-Watch-Box-with-Clear-Display-Lid-LeeAnn-good-03f73dc0fb1d2de517d07eb9f00ff5ae.jpg?v=1786997970",
      "product": {
        "title": "5-Slot Wooden Watch Box with Clear Display Lid",
        "url": "/products/watch-box-3",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-5-Slot-Wooden-Watch-Box-with-Clear-Display-Lid-LeeAnn-good-03f73dc0fb1d2de517d07eb9f00ff5ae.jpg?v=1786997970"
      }
    },
    {
      "name": "G",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "Beautiful craftsmanship! Perfect for my special pieces. The double doors make necklaces much easier to reach.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Cabinet-with-Double-Doors-5-Drawers-G-good-89778ff0d45660ff9d472ba4eb44f111.jpg?v=1786998018",
      "product": {
        "title": "Lockable Walnut Jewelry Cabinet with Double Doors & 5 Drawers",
        "url": "/products/lockable-walnut-jewelry-cabinet-with-double-doors-5-drawers",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Cabinet-with-Double-Doors-5-Drawers-G-good-89778ff0d45660ff9d472ba4eb44f111.jpg?v=1786998018"
      }
    },
    {
      "name": "Clayton",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "Lovely piece! My daughter received it as a gift and loved it. The necklace hooks were the part she noticed first.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Necklace-Hooks-Ring-Storage-Clayton-good-47af2675c61b60d6af763c2dbc5714c9.jpg?v=1786998043",
      "product": {
        "title": "Lockable Walnut Jewelry Box with Necklace Hooks & Ring Storage",
        "url": "/products/lockable-walnut-jewelry-box-with-necklace-hooks-ring-storage",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Necklace-Hooks-Ring-Storage-Clayton-good-47af2675c61b60d6af763c2dbc5714c9.jpg?v=1786998043"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "The jewelry box is exactly as described and seems to be high quality. The side doors are useful for necklaces.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Mirror-Side-Doors-4-Drawers-3-good-aca3e844fb5f5f8da7fdf8cad5478566.jpg?v=1786998102",
      "product": {
        "title": "Lockable Walnut Jewelry Box with Mirror, Side Doors & 4 Drawers",
        "url": "/products/lockable-walnut-jewelry-box-with-mirror-side-doors-4-drawers",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Mirror-Side-Doors-4-Drawers-3-good-aca3e844fb5f5f8da7fdf8cad5478566.jpg?v=1786998102"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "Beautiful and practical. The mirror is handy when I am putting earrings on, and the drawers keep the small pieces separate.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Mirror-Side-Doors-4-Drawers-Etsy-buyer-good-52cfcd3928ccfad6dcef470b2ef69091.jpg?v=1786998260",
      "product": {
        "title": "Lockable Walnut Jewelry Box with Mirror, Side Doors & 4 Drawers",
        "url": "/products/lockable-walnut-jewelry-box-with-mirror-side-doors-4-drawers",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-Mirror-Side-Doors-4-Drawers-Etsy-buyer-good-52cfcd3928ccfad6dcef470b2ef69091.jpg?v=1786998260"
      }
    },
    {
      "name": "Kelsey",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "Looks great, my wife loved it. I ordered it for a gift and it felt personal without needing much else.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-4-Drawers-Necklace-Hooks-Kelsey-good-6d6fd604ec0e9eb3e04b233ff1608782.jpg?v=1786998298",
      "product": {
        "title": "Lockable Walnut Jewelry Box with 4 Drawers & Necklace Hooks",
        "url": "/products/lockable-walnut-jewelry-box-with-4-drawers-necklace-hooks",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Lockable-Walnut-Jewelry-Box-with-4-Drawers-Necklace-Hooks-Kelsey-good-6d6fd604ec0e9eb3e04b233ff1608782.jpg?v=1786998298"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "It is compact, but it fits the jewelry I actually wear every week. The hooks are great for small necklaces.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Compact-Walnut-Jewelry-Box-with-Necklace-Hooks-Ring-Storage-1-copy-13-good-743a6e0005407ddb773896ca6340f948.jpg?v=1786998643",
      "product": {
        "title": "Compact Walnut Jewelry Box with Necklace Hooks & Ring Storage",
        "url": "/products/compact-walnut-jewelry-box-with-necklace-hooks-ring-storage",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-Compact-Walnut-Jewelry-Box-with-Necklace-Hooks-Ring-Storage-1-copy-13-good-743a6e0005407ddb773896ca6340f948.jpg?v=1786998643"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "The tray in front is actually more useful than I thought. I keep a strap tool and a couple of bands there, and the watches stay lined up nicely.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-7-Slot-Wooden-Watch-Box-with-Accessory-Tray-Clear-Lid-1-copy-2-good-5fbea77c5f3c005de664a14a76e1f011.jpg?v=1786998861",
      "product": {
        "title": "7-Slot Wooden Watch Box with Accessory Tray & Clear Lid",
        "url": "/products/watch-box-4",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-7-Slot-Wooden-Watch-Box-with-Accessory-Tray-Clear-Lid-1-copy-2-good-5fbea77c5f3c005de664a14a76e1f011.jpg?v=1786998861"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "My watches were sitting in separate boxes before, so this already feels like an upgrade. The clear lid makes the whole thing look more organized.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-7-Slot-Wooden-Watch-Box-with-Accessory-Tray-Clear-Lid-1-copy-good-652cf50b4fab722ab64e5196eec76e02.jpg?v=1786998948",
      "product": {
        "title": "7-Slot Wooden Watch Box with Accessory Tray & Clear Lid",
        "url": "/products/watch-box-4",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-7-Slot-Wooden-Watch-Box-with-Accessory-Tray-Clear-Lid-1-copy-good-652cf50b4fab722ab64e5196eec76e02.jpg?v=1786998948"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "The vertical drawers make small pieces much easier to sort. It is compact, but still holds more than I thought it would.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-6-Drawer-Vertical-Walnut-Jewelry-Cabinet-with-Brass-Handle-8-good-771f567ee581cf86e6ff3ccfcdaf13bf.jpg?v=1786999272",
      "product": {
        "title": "6-Drawer Vertical Walnut Jewelry Cabinet with Brass Handle",
        "url": "/products/6-drawer-vertical-walnut-jewelry-cabinet-with-brass-handle",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-6-Drawer-Vertical-Walnut-Jewelry-Cabinet-with-Brass-Handle-8-good-771f567ee581cf86e6ff3ccfcdaf13bf.jpg?v=1786999272"
      }
    },
    {
      "name": "Etsy Customer",
      "verified": "Verified review",
      "rating": "★★★★★",
      "body": "I like having separate drawers instead of one big open space. Rings and earrings are much easier to find now.",
      "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-6-Drawer-Vertical-Walnut-Jewelry-Cabinet-with-Brass-Handle-9-good-153d3decefcc5fcc206602b66d0c85ee.jpg?v=1786999306",
      "product": {
        "title": "6-Drawer Vertical Walnut Jewelry Cabinet with Brass Handle",
        "url": "/products/6-drawer-vertical-walnut-jewelry-cabinet-with-brass-handle",
        "image": "https://cdn.shopify.com/s/files/1/0703/1246/0538/files/review-6-Drawer-Vertical-Walnut-Jewelry-Cabinet-with-Brass-Handle-9-good-153d3decefcc5fcc206602b66d0c85ee.jpg?v=1786999306"
      }
    }
  ];

  function cleanText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function textFrom(root, selectors) {
    var node = root.querySelector(selectors);
    return node ? cleanText(node.textContent) : '';
  }

  function productMap(root) {
    var script = root.querySelector('[data-te-product-map]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (error) { return []; }
  }

  function productFor(card, root, products) {
    if (root.dataset.reviewMode === 'product') {
      return {
        title: root.dataset.productTitle || '',
        url: root.dataset.productUrl || '#',
        image: root.dataset.productImage || ''
      };
    }

    var link = card.querySelector('a[href*="/products/"]');
    if (link) {
      var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
      if (match) {
        var foundByHandle = products.find(function (item) { return item.handle === match[1]; });
        if (foundByHandle) return foundByHandle;
      }
    }

    var title = textFrom(card, '.jdgm-carousel-item__product-title, [data-product-title]').toLowerCase();
    return products.find(function (item) {
      var productTitle = item.title.toLowerCase();
      return title && (productTitle.indexOf(title) > -1 || title.indexOf(productTitle) > -1);
    }) || null;
  }

  function imageSrc(image) {
    if (!image) return '';
    var fromSrcset = image.getAttribute('srcset') || image.dataset.srcset || '';
    if (fromSrcset) {
      var first = fromSrcset.split(',')[0];
      if (first) return first.trim().split(/\s+/)[0];
    }
    return image.currentSrc || image.getAttribute('src') || image.dataset.src || '';
  }

  function realMedia(card) {
    var candidates = card.querySelectorAll(reviewMediaSelector);
    for (var i = 0; i < candidates.length; i += 1) {
      var image = candidates[i];
      var src = imageSrc(image);
      if (!src || src.indexOf('data:image') === 0) continue;
      if (image.closest('.te-review-fallback-media')) continue;
      return src;
    }
    return '';
  }

  function ratingText(card) {
    var rating = card.querySelector('.jdgm-carousel-item__review-rating, .jdgm-rev__rating, [data-rating]');
    if (!rating) return '★★★★★';

    var label = rating.getAttribute('aria-label') || rating.getAttribute('title') || '';
    var match = label.match(/([0-5](?:\.\d)?)/);
    var count = match ? Math.round(parseFloat(match[1])) : 5;
    return '★★★★★'.slice(0, count) + '☆☆☆☆☆'.slice(0, 5 - count);
  }

  function reviewData(card, root, products) {
    var product = productFor(card, root, products) || {};
    var image = realMedia(card);
    var fallback = false;

    if (!image && product.image) {
      image = product.image;
      fallback = true;
    }

    return {
      name: textFrom(card, '.jdgm-carousel-item__reviewer-name, .jdgm-rev__author, [data-reviewer-name]') || 'Customer',
      verified: textFrom(card, '.jdgm-rev__buyer-badge, .jdgm-verified-badge, .jdgm-verified-buyer-badge, [data-verified]') || 'Verified review',
      rating: ratingText(card),
      body: textFrom(card, '.jdgm-carousel-item__review-body, .jdgm-rev__body, [data-review-body]'),
      image: image || '',
      fallback: fallback,
      product: product
    };
  }

  function collectReviews(root) {
    var products = productMap(root);
    var nativeCards = Array.prototype.slice.call(root.querySelectorAll(nativeCardSelector));

    return nativeCards.map(function (card, index) {
      var item = reviewData(card, root, products);
      if (root.dataset.reviewMode === 'home') {
        var featured = homepageFeaturedReviews[index % homepageFeaturedReviews.length];
        if (featured) {
          item.image = item.image || featured.image;
          item.product = item.product && item.product.title ? item.product : featured.product;
          item.body = item.body || featured.body;
          item.name = item.name === 'Customer' ? featured.name : item.name;
          item.verified = item.verified || featured.verified;
          item.rating = item.rating || featured.rating;
        }
      }
      return item;
    }).filter(function (item) {
      return item.image || item.body || item.name !== 'Customer';
    });
  }

  function summaryText(root, reviews) {
    var candidates = [
      textFrom(root, '.jdgm-carousel-number-of-reviews'),
      textFrom(root, '.jdgm-rev-widg__summary-text'),
      textFrom(root, '.jdgm-all-reviews-text'),
      textFrom(root, '.jdgm-widget-actions-wrapper + *')
    ].filter(Boolean);

    var found = candidates.find(function (text) { return /\d/.test(text); });
    if (found) return found;
    return reviews.length ? reviews.length + ' reviews' : '';
  }

  function renderShell(root, reviews) {
    var shell = root.querySelector('[data-te-loox-shell]');
    var track = root.querySelector('[data-te-loox-track]');
    if (!shell || !track || !reviews.length) return;

    var visibleReviews = reviews.slice(0, root.dataset.reviewMode === 'product' ? 6 : 8);
    track.innerHTML = '';

    visibleReviews.forEach(function (review, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = review.image ? 'te-loox-card' : 'te-loox-card te-loox-card--no-image';
      button.dataset.teReviewIndex = String(index);

      if (review.image) {
        var image = document.createElement('img');
        image.className = 'te-loox-card__image';
        image.src = review.image;
        image.alt = review.product.title || 'Customer review';
        image.loading = 'lazy';
        image.onerror = function () {
          var fallbackSrc = review.product && review.product.image ? review.product.image : '';
          if (fallbackSrc && image.src !== fallbackSrc) {
            image.src = fallbackSrc;
            review.image = fallbackSrc;
            review.fallback = true;
            return;
          }
          image.removeAttribute('src');
          image.style.display = 'none';
          button.classList.add('te-loox-card--no-image');
        };
        button.appendChild(image);
      }

      if (review.fallback) {
        var note = document.createElement('span');
        note.className = 'te-loox-card__note';
        note.textContent = 'Product image';
        button.appendChild(note);
      }

      var content = document.createElement('span');
      content.className = 'te-loox-card__content';
      content.innerHTML = [
        '<span class="te-loox-card__name"></span>',
        '<span class="te-loox-card__rating"></span>',
        '<span class="te-loox-card__quote"></span>',
        '<span class="te-loox-card__product"></span>'
      ].join('');
      content.querySelector('.te-loox-card__name').innerHTML = '';
      content.querySelector('.te-loox-card__name').appendChild(document.createTextNode(review.name));
      if (review.verified) {
        var verified = document.createElement('span');
        verified.className = 'te-loox-card__verified';
        verified.textContent = '✓';
        verified.title = review.verified;
        content.querySelector('.te-loox-card__name').appendChild(verified);
      }
      content.querySelector('.te-loox-card__rating').textContent = review.rating;
      content.querySelector('.te-loox-card__quote').textContent = review.body;
      content.querySelector('.te-loox-card__product').textContent = review.product.title || '';
      button.appendChild(content);

      track.appendChild(button);
    });

    var summary = root.querySelector('[data-te-loox-summary]');
    var summaryStars = root.querySelector('[data-te-loox-summary-stars]');
    var summaryCount = root.querySelector('[data-te-loox-summary-count]');
    if (summary && summaryStars && summaryCount) {
      summaryStars.textContent = '★★★★★';
      summaryCount.textContent = summaryText(root, reviews);
      summary.hidden = !summaryCount.textContent;
    }

    root.classList.add('te-reviews-enhanced');
    shell.hidden = false;
    bindShell(root, visibleReviews);
  }

  function dialogController(root, reviews) {
    var dialog = root.querySelector('[data-te-review-dialog]');
    if (!dialog) return null;
    var currentIndex = 0;

    function show(index) {
      if (!reviews.length) return;
      currentIndex = (index + reviews.length) % reviews.length;
      var data = reviews[currentIndex];
      var image = dialog.querySelector('[data-te-dialog-image]');
      image.onerror = function () {
        var fallbackSrc = data.product && data.product.image ? data.product.image : '';
        if (fallbackSrc && image.src !== fallbackSrc) {
          image.src = fallbackSrc;
          return;
        }
        image.removeAttribute('src');
      };
      image.src = data.image || (data.product && data.product.image ? data.product.image : '');
      image.alt = data.product.title || 'Customer review';
      dialog.querySelector('[data-te-dialog-name]').textContent = data.name;
      dialog.querySelector('[data-te-dialog-verified]').textContent = data.verified || 'Verified review';
      dialog.querySelector('[data-te-dialog-rating]').textContent = data.rating;
      dialog.querySelector('[data-te-dialog-body]').textContent = data.body || 'Shared by a verified customer.';

      var productLink = dialog.querySelector('[data-te-dialog-product]');
      var productImage = dialog.querySelector('[data-te-dialog-product-image]');
      productLink.href = data.product.url || '#';
      productImage.src = data.product.image || data.image;
      productImage.alt = data.product.title || '';
      dialog.querySelector('[data-te-dialog-product-title]').textContent = data.product.title || '';
      productLink.hidden = !data.product.title;
    }

    function open(index) {
      show(index);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    if (dialog.dataset.teReady !== 'true') {
      dialog.dataset.teReady = 'true';
      dialog.querySelector('[data-te-review-close]').addEventListener('click', function () { dialog.close(); });
      dialog.querySelector('[data-te-review-previous]').addEventListener('click', function () { show(currentIndex - 1); });
      dialog.querySelector('[data-te-review-next]').addEventListener('click', function () { show(currentIndex + 1); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    }

    return open;
  }

  function bindShell(root, reviews) {
    var track = root.querySelector('[data-te-loox-track]');
    if (!track) return;
    var open = dialogController(root, reviews);

    track.querySelectorAll('.te-loox-card').forEach(function (card) {
      if (card.dataset.teBound === 'true') return;
      card.dataset.teBound = 'true';
      card.addEventListener('click', function () {
        if (open) open(parseInt(card.dataset.teReviewIndex, 10) || 0);
      });
    });

    var previous = root.querySelector('[data-te-loox-prev]');
    var next = root.querySelector('[data-te-loox-next]');
    if (previous && previous.dataset.teBound !== 'true') {
      previous.dataset.teBound = 'true';
      previous.addEventListener('click', function () {
        track.scrollBy({ left: -Math.max(260, track.clientWidth * 0.7), behavior: 'smooth' });
      });
    }
    if (next && next.dataset.teBound !== 'true') {
      next.dataset.teBound = 'true';
      next.addEventListener('click', function () {
        track.scrollBy({ left: Math.max(260, track.clientWidth * 0.7), behavior: 'smooth' });
      });
    }
  }

  function enhance(root) {
    var reviews = collectReviews(root);
    if (!reviews.length) return;
    renderShell(root, reviews);
  }

  function boot(root) {
    var queued = false;
    function queueEnhance() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enhance(root);
      });
    }

    queueEnhance();
    var app = root.querySelector('.te-product-reviews-host__app');
    if (app) new MutationObserver(queueEnhance).observe(app, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('[data-te-reviews-root]').forEach(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
